/**
 * The node and every node after it in the flow: everything its connections
 * lead to. Shift+click selects these.
 */
export function getNodeAndAfter(
  nodeId: string,
  edges: { source: string; target: string }[],
): string[] {
  const outgoing = new Map<string, string[]>();
  edges.forEach((edge) =>
    outgoing.set(edge.source, [...(outgoing.get(edge.source) ?? []), edge.target]),
  );
  const seen = new Set<string>([nodeId]);
  const queue = [nodeId];
  while (queue.length > 0) {
    (outgoing.get(queue.shift()!) ?? []).forEach((target) => {
      if (seen.has(target)) return;
      seen.add(target);
      queue.push(target);
    });
  }
  return [...seen];
}
